import { ApiService } from "../_services";
import {ILoginDetails, SignUpDetails} from "../common/";

const login = (username: string, password: string) => {
  const client = new ApiService();
  const payload: ILoginDetails = {
    "email": username,
    "password": password
  };
  return client.post("/authenticationTokens", payload)
    .then(response => {
      const data = response.data;
      if (data.token) {
        localStorage.setItem("user_data", JSON.stringify(data));
      }
      return data;
    }).then(data => {
      client.setAuthHeader();
      const path = `/profiles?userId=${data.userId}`;

      return client.get(path)
        .then(response => {
          if (!response) {
            console.log("error fetching user profile");
            return {};
          }
          const profileData = response.data[0] || {};
          if (profileData.bestWayToBeReached !== "" && profileData.bestWayToBeReached !== undefined) {
            localStorage.setItem("onboarded", true);
          } else {
            localStorage.setItem("onboarded", false);
          }
          return data;
        });
    });
};

const signUp = (email: string, password: string, role: string, devices: string) => {
    const client = new ApiService();
    const payload: SignUpDetails = {
        "email": email,
        "password": password,
        "role": role,
        "devices": devices
    };
    return client.post("/users", payload)
        .then(response => {
            const data = response.data.authenticationToken;
            if (data.token) {
                localStorage.setItem("user_data", JSON.stringify(data));
            }
            return data;
        })
        .catch(err => {
            throw err;
        })
}

const logout = () => {
  localStorage.removeItem("user_data");
  localStorage.removeItem("onboarded");
};

export const authService = {
    login,
    logout,
    signUp,
};
